export default __webpack_public_path__ + "static/media/jojo.79465a3e.jpg";